/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feRepeat', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherRepeatIconData */

/** @type {FeatherRepeatIconData} */
const feRepeat = {
  prefix: 'fe',
  iconName: 'repeat',
  icon: [
    24,
    24,
    '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-repeat"><path d="M17 1 L21 5 L17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23 L3 19 L7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
    'M17 1 L21 5 L17 9 M3 11V9a4 4 0 0 1 4-4h14 M7 23 L3 19 L7 15 M21 13v2a4 4 0 0 1-4 4H3',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feRepeat
